import { render, staticRenderFns } from "./About_generali.vue?vue&type=template&id=bc13019c&scoped=true"
import script from "./About_generali.vue?vue&type=script&lang=js"
export * from "./About_generali.vue?vue&type=script&lang=js"
import style0 from "./About_generali.vue?vue&type=style&index=0&id=bc13019c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc13019c",
  null
  
)

export default component.exports